import { Fragment } from "react";
import { Divider, Spin, Typography } from "antd";
import { useSelector } from "react-redux";

import { IOrgaoComErro } from "../../../../../interfaces";
import { stateGlobal } from "../../../../../../../../interfaces/Global";

import { mask } from "../../../../../../../../utils/MascaraDeCampos";
import ContaComErro from "../ContaComErro";

interface IProps {
    data: IOrgaoComErro[] | undefined;
    isLoadingOrgaos: boolean;
    onClickToggleContaAtiva: ({ contaId, ativa }: { contaId: number; ativa: boolean; }) => Promise<void>;
    emptyText: string;
    isManutencao?: boolean;
}

export default function ContasComErroContent({
    data,
    isLoadingOrgaos,
    onClickToggleContaAtiva,
    emptyText,
    isManutencao = false,
}: IProps) {
    const propsState = useSelector((state: stateGlobal) => state.global);

    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 12,
            }}
        >
            {
                !isLoadingOrgaos && !data?.length && (
                    <Typography.Paragraph>{emptyText}</Typography.Paragraph>
                )
            }

            {
                data?.map((orgao) => (
                    <div
                        key={orgao.id}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontWeight: 500,
                            border: `1px solid ${propsState.theme === 'light' ? '#0000000f' : '#ffffff1f'}`,
                            padding: '12px 16px',
                            borderRadius: 8,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography.Text strong>{orgao.nome}</Typography.Text>

                            <Typography.Text
                                type="secondary"
                                style={{
                                    fontSize: 12
                                }}
                            >
                                CNPJ: <Typography.Text style={{ color: '#2B98FF' }}>{mask(orgao.cnpj, ["99.999.999/9999-99"])}</Typography.Text>
                            </Typography.Text>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                marginLeft: 20,
                                marginTop: 8,
                                gap: 8
                            }}
                        >
                            {
                                orgao.bancos.map((banco) => (
                                    <div
                                        key={banco.id}
                                        style={{
                                            border: `1px solid ${propsState.theme === 'light' ? '#0000000f' : '#ffffff1f'}`,
                                            borderRadius: 8,
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 6,
                                                padding: 8,
                                                backgroundColor: propsState.theme === 'light' ? '#f0f2f56f' : '#00000036',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor: "#FFFFFF",
                                                    width: 24,
                                                    height: 24,
                                                    borderRadius: 24,
                                                    overflow: 'hidden',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    border: `1px solid ${propsState.theme === 'light' ? '#0000000f' : '#6f6d6d95'}`,
                                                }}
                                            >
                                                {
                                                    banco.imageUrl && (
                                                        <img
                                                            src={banco.imageUrl}
                                                            width={24}
                                                            height={24}
                                                            style={{ borderRadius: 24 }}
                                                        />
                                                    )
                                                }

                                            </div>

                                            <Typography.Text>{banco.nome}</Typography.Text>
                                        </div>

                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            {
                                                banco.contas.map((conta, index) => (
                                                    <Fragment key={conta.id}>
                                                        <ContaComErro
                                                            conta={conta}
                                                            onClickToggleContaAtiva={onClickToggleContaAtiva}
                                                            isManutencao={isManutencao}
                                                        />

                                                        {
                                                            index < (banco.contas.length - 1) && (
                                                                <Divider style={{ margin: 0 }} />
                                                            )
                                                        }
                                                    </Fragment>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                ))
            }

            {
                isLoadingOrgaos && (
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 8,
                        }}
                    >
                        <Spin />
                    </div>
                )
            }
        </div>
    )
}
